<template>
	<div class="az-text">
		<label :style="{ color: `${color} !important`, fontSize: `${fontSize} !important` }">{{ nomeCampo }}</label>
		<span v-if="obrigatorioPorPadrao" class="red--text">*</span>
		<tooltip-informativo
			v-if="apresentaTooltip"
			id="tooltipInformativo"
			:mensagemPadraoTooltip="mensagemPadraoTooltip"
		></tooltip-informativo>
	</div>
</template>

<script>
import TooltipInformativo from "@/views/credenciamento/detalhe-credenciamento/commons/TooltipInformativo.vue";

export default {
	name: 'label-personalizado',
	components: {TooltipInformativo},
	props: {
		apresentaTooltip: {
			type: Boolean,
		},
		nomeCampo: {
			type: String,
			required: true,
		},
		obrigatorioPorPadrao: {
			type: Boolean,
		},
		mensagemPadraoTooltip: {
			type: String,
			default: 'mensagem',
		},
		color: {
			type: String,
			default: '#777',
		},
		fontSize: {
			type: String,
			default: '',
		},
	},
}
</script>
